/* eslint-disable no-unused-vars */
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import axios from "axios";
// Modules
import auth from "./modules/auth";
import user from "./modules/user";
import calendar from "./modules/calendar";
import calendarFinances from "./modules/calendarFinances";
import calendarMaintenance from "./modules/calendarMaintenance";
import contact from "./modules/contact";
import technical_support from "./modules/technical_support";
import customers from "./modules/customers";
import deals from "./modules/deals";
import prospects from "./modules/prospects";
import my_request from "./modules/my_request";
import employees from "./modules/employees";

// Dialogs
import interactions from "./dialogs/interactions";
import products from "./dialogs/products";
import request_types from "./dialogs/request_types";
import currency from "./dialogs/currency";
import times from "./dialogs/times";
import deal_of_type from "./dialogs/deal_of_type";
import sellers from "./dialogs/sellers";
import support_sellers from "./dialogs/support_sellers";
import customer_services from "./dialogs/customer_services";
import technicians from "./dialogs/technicians";

// Component
import rabbey_table from "./components/rabbey_table";
import rabbey_tabs from "./components/rabbey_tabs";

// Apps
import message from "./system/message";
import comment from "./system/comment";
import navixy from "./system/navixy";
import inventory from "./system/inventory";
// mpago reports
import ncfmovil from "./modules/ncfmovil";

// personal manager
import productivity from "./modules/productivity";

//Activity Flow
import activityFlow from "@/store/modules/activityFlow.js";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    auth,
    user,
    calendar,
    calendarFinances,
    calendarMaintenance,
    interactions,
    contact,
    products,
    rabbey_table,
    request_types,
    technical_support,
    currency,
    times,
    deal_of_type,
    customers,
    employees,
    deals,
    sellers,
    message,
    comment,
    rabbey_tabs,
    navixy,
    inventory,
    prospects,
    my_request,
    ncfmovil,
    productivity,
    support_sellers,
    customer_services,
    technicians,
    activityFlow
  },
  state: {
    TaskCount: 0,
    totalObjectiveTaskCount: 0,
    objectiveCount: 0,
    layout: {
      navPos: "left", //top, bottom, left, right, false
      toolbar: "top", //top, bottom, false
      footer: true, //above, below, false
      boxed: false, //true, false
      roundedCorners: false, //true, false
      viewAnimation: "fade-top" // fade-left, fade-right, fade-top, fade-top-in-out, fade-bottom, fade-bottom-in-out, fade, false
    },
    splashScreen: true,
    mainActiveMenu: "",
    updateInternalRequests: false,
    updateCompany: false
  },
  mutations: {
    updateBadgetCount1(state, payload) {
      state.objectiveCount = payload.cantidadObjetivos;
      state.TaskCount = payload.cantidadTareas;
      state.totalObjectiveTaskCount = payload.total;
      // this.peddingCount =this.$store.state.objectiveCount;
    },

    setLayout(state, payload) {
      if (payload && payload.navPos !== undefined)
        state.layout.navPos = payload.navPos;

      if (payload && payload.toolbar !== undefined)
        state.layout.toolbar = payload.toolbar;

      if (payload && payload.footer !== undefined)
        state.layout.footer = payload.footer;

      if (payload && payload.boxed !== undefined)
        state.layout.boxed = payload.boxed;

      if (payload && payload.roundedCorners !== undefined)
        state.layout.roundedCorners = payload.roundedCorners;

      if (payload && payload.viewAnimation !== undefined)
        state.layout.viewAnimation = payload.viewAnimation;
    },
    setSplashScreen(state, payload) {
      state.splashScreen = payload;
    },
    setMainActiveMenu(state, payload) {
      state.mainActiveMenu = payload;
    },
    SET_UPDATE_INTERNAL_REQUESTS(state, payload) {
      state.updateInternalRequests = payload;
    },
    TOGGLE_UPDATE_COMPANY(state, payload) {
      state.updateCompany = payload;
    }
  },
  actions: {
    updateBadgetCount({ commit }, thisNav) {
      thisNav.$http
        .get(
          `/api/CMI/Objetives/Pedding?ResponsableId=${thisNav.currentUser.EmployeeId}`
        )
        .then(({ data }) => {
          commit("updateBadgetCount1", data);
          // this.peddingCount =this.$store.state.objectiveCount;
        });
    },

    initialDataModules: ({ dispatch }) => {
      try {
        dispatch("products/fetchProducts", null, { root: true });
        dispatch("sellers/fetchSellers", null, { root: true });
        dispatch("sellers/fetchSellersEmployee", null, { root: true });
        dispatch("support_sellers/fetchSupportSellers", null, { root: true });
        dispatch("support_sellers/fetchSupportSellersEmployee", null, {
          root: true
        });
        dispatch("customer_services/fetchCustomerServices", null, {
          root: true
        });
        dispatch("customer_services/fetchCustomerServicesEmployee", null, {
          root: true
        });
        dispatch("customer_services/fetchCustomerServicesEmployeeId", null, {
          root: true
        });
        dispatch("request_types/fetchRequesTypes", null, { root: true });
        dispatch("technicians/fetchTechnicians", null, { root: true });
        //dispatch("productivity/GetInteralRequest");
      } catch (error) {
        return Promise.reject(error);
      }
    }
  },
  getters: {
    GetTotalCount(state) {
      return state.totalObjectiveTaskCount;
    },
    GetTaskTotalCount(state) {
      return state.TaskCount;
    },
    GetObjectiveTotalCount(state) {
      return state.objectiveCount;
    },
    layout(state, getters) {
      return state.layout;
    },
    navPos(state, getters) {
      return state.layout.navPos;
    },
    toolbar(state, getters) {
      return state.layout.toolbar;
    },
    footer(state, getters) {
      return state.layout.footer;
    },
    boxed(state, getters) {
      return state.layout.boxed;
    },
    roundedCorners(state, getters) {
      return state.layout.roundedCorners;
    },
    viewAnimation(state, getters) {
      return state.layout.viewAnimation;
    },
    splashScreen(state, getters) {
      return state.splashScreen;
    },
    mainActiveMenu(state, getters) {
      return state.mainActiveMenu;
    }
  },
  plugins: [
    createPersistedState({
      paths: [
        "layout",
        "user",
        "auth",
        "sellers",
        "currency",
        "times",
        "deal_of_type"
      ]
    })
  ],
  strict: debug
});
